(function(){'use strict';
var CANVAS_PX = 1200;
var WORK_LONG = 420;
function $(sel, root) { return (root || document).querySelector(sel); }
function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
var INF = 1e20;
function edt1d(f, n, d, v, z) {
var k = 0; v[0] = 0; z[0] = -INF; z[1] = INF;
for (var q = 1; q < n; q++) {
var s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
while (s <= z[k]) { k--; s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]); }
k++; v[k] = q; z[k] = s; z[k + 1] = INF;
}
k = 0;
for (var q2 = 0; q2 < n; q2++) {
while (z[k + 1] < q2) k++;
var dq = q2 - v[k];
d[q2] = dq * dq + f[v[k]];
}
}
function distanceOutside(mask, w, h) {
var grid = new Float64Array(w * h);
for (var i = 0; i < w * h; i++) grid[i] = mask[i] ? 0 : INF;
var n = Math.max(w, h);
var f = new Float64Array(n), d = new Float64Array(n), v = new Int32Array(n), z = new Float64Array(n + 1);
for (var x = 0; x < w; x++) {
for (var y = 0; y < h; y++) f[y] = grid[y * w + x];
edt1d(f, h, d, v, z);
for (var y2 = 0; y2 < h; y2++) grid[y2 * w + x] = d[y2];
}
for (var y3 = 0; y3 < h; y3++) {
for (var x2 = 0; x2 < w; x2++) f[x2] = grid[y3 * w + x2];
edt1d(f, w, d, v, z);
for (var x3 = 0; x3 < w; x3++) grid[y3 * w + x3] = Math.sqrt(d[x3]);
}
return grid;
}
function fillHoles(mask, w, h) {
var seen = new Uint8Array(w * h), stack = [];
function push(i) { if (!mask[i] && !seen[i]) { seen[i] = 1; stack.push(i); } }
for (var x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
for (var y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
while (stack.length) {
var i = stack.pop(), px = i % w, py = (i / w) | 0;
if (px > 0) push(i - 1); if (px < w - 1) push(i + 1);
if (py > 0) push(i - w); if (py < h - 1) push(i + w);
}
for (var j = 0; j < w * h; j++) if (!seen[j]) mask[j] = 1;
return mask;
}
function countComponents(mask, w, h) {
var seen = new Uint8Array(w * h), n = 0, stack = [];
for (var s = 0; s < w * h; s++) {
if (!mask[s] || seen[s]) continue;
n++; if (n > 1) return n;
seen[s] = 1; stack.push(s);
while (stack.length) {
var i = stack.pop(), x = i % w, y = (i / w) | 0;
if (x > 0 && mask[i - 1] && !seen[i - 1]) { seen[i - 1] = 1; stack.push(i - 1); }
if (x < w - 1 && mask[i + 1] && !seen[i + 1]) { seen[i + 1] = 1; stack.push(i + 1); }
if (y > 0 && mask[i - w] && !seen[i - w]) { seen[i - w] = 1; stack.push(i - w); }
if (y < h - 1 && mask[i + w] && !seen[i + w]) { seen[i + w] = 1; stack.push(i + w); }
}
}
return n;
}
function maskToCanvas(mask, w, h, rgba) {
var c = document.createElement('canvas'); c.width = w; c.height = h;
var ctx = c.getContext('2d'), img = ctx.createImageData(w, h), d = img.data;
for (var i = 0; i < w * h; i++) {
if (mask[i]) { d[i * 4] = rgba[0]; d[i * 4 + 1] = rgba[1]; d[i * 4 + 2] = rgba[2]; d[i * 4 + 3] = rgba[3]; }
}
ctx.putImageData(img, 0, 0);
return c;
}
function analyzeArt(img, removeBg) {
var maxSide = 1400;
var sc = Math.min(1, maxSide / Math.max(img.naturalWidth || img.width, img.naturalHeight || img.height));
var w = Math.max(1, Math.round((img.naturalWidth || img.width) * sc));
var h = Math.max(1, Math.round((img.naturalHeight || img.height) * sc));
var c = document.createElement('canvas'); c.width = w; c.height = h;
var ctx = c.getContext('2d', { willReadFrequently: true });
ctx.drawImage(img, 0, 0, w, h);
var data;
try { data = ctx.getImageData(0, 0, w, h); } catch (e) { return { canvas: c, hasAlpha: false, bgRemovable: false, tainted: true }; }
var d = data.data, transparent = 0;
for (var i = 3; i < d.length; i += 4) if (d[i] < 200) transparent++;
var hasAlpha = transparent > (w * h) * 0.01;
var bgRemovable = false;
if (!hasAlpha) {
var corners = [0, w - 1, (h - 1) * w, h * w - 1].map(function (p) { return [d[p * 4], d[p * 4 + 1], d[p * 4 + 2]]; });
var ref = corners[0], similar = corners.every(function (cc) {
return Math.abs(cc[0] - ref[0]) + Math.abs(cc[1] - ref[1]) + Math.abs(cc[2] - ref[2]) < 60;
});
bgRemovable = similar;
if (similar && removeBg) {
var tol = 70, seen = new Uint8Array(w * h), stack = [];
var near = function (p) {
return Math.abs(d[p * 4] - ref[0]) + Math.abs(d[p * 4 + 1] - ref[1]) + Math.abs(d[p * 4 + 2] - ref[2]) < tol;
};
var push = function (p) { if (!seen[p] && near(p)) { seen[p] = 1; stack.push(p); } };
for (var x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
for (var y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
while (stack.length) {
var p = stack.pop(), px = p % w, py = (p / w) | 0;
if (px > 0) push(p - 1); if (px < w - 1) push(p + 1);
if (py > 0) push(p - w); if (py < h - 1) push(p + w);
}
for (var q = 0; q < w * h; q++) if (seen[q]) d[q * 4 + 3] = 0;
ctx.putImageData(data, 0, 0);
hasAlpha = true;
}
}
var minX = w, minY = h, maxX = -1, maxY = -1;
for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
if (d[(yy * w + xx) * 4 + 3] > 40) {
if (xx < minX) minX = xx; if (xx > maxX) maxX = xx;
if (yy < minY) minY = yy; if (yy > maxY) maxY = yy;
}
}
if (maxX < 0) { minX = 0; minY = 0; maxX = w - 1; maxY = h - 1; }
var tw = maxX - minX + 1, th = maxY - minY + 1;
var t = document.createElement('canvas'); t.width = tw; t.height = th;
t.getContext('2d').drawImage(c, minX, minY, tw, th, 0, 0, tw, th);
return { canvas: t, hasAlpha: hasAlpha, bgRemovable: bgRemovable };
}
function sampleArt() {
var c = document.createElement('canvas'); c.width = 900; c.height = 700;
var g = c.getContext('2d');
g.translate(450, 350);
g.fillStyle = '#e6007e';
g.beginPath();
for (var i = 0; i < 10; i++) {
var r = i % 2 ? 150 : 330, a = -Math.PI / 2 + i * Math.PI / 5;
g.lineTo(Math.cos(a) * r, Math.sin(a) * r * 0.95);
}
g.closePath(); g.fill();
g.fillStyle = '#ffd400';
g.beginPath(); g.arc(0, 30, 120, 0, Math.PI * 2); g.fill();
g.fillStyle = '#111';
g.font = 'bold 74px Arial, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle';
g.fillText('YOUR', 0, 0); g.fillText('ART', 0, 70);
return { canvas: c, hasAlpha: true, bgRemovable: false, sample: true };
}
function parseLen(v){
var m=String(v||'').match(/(\d+(?:\.\d+)?)\s*(″|"|in\b|inch|ft\b|feet|foot|')?/i); if(!m) return null;
var n=parseFloat(m[1]), u=(m[2]||'').toLowerCase();
return /ft|feet|foot|'/.test(u)?n*12:n;
}
function parsePair(v){
var s=String(v||'');
var m=s.match(/(\d+(?:\.\d+)?)\s*(″|"|in|ft|')?\s*[×xX]\s*(\d+(?:\.\d+)?)\s*(″|"|in|ft|feet|')?/);
if(!m) return null;
var ft=/ft|feet|'/.test((m[2]||'')+(m[4]||'')+s.slice(m.index+m[0].length,m.index+m[0].length+4));
var a=parseFloat(m[1]), b=parseFloat(m[3]);
return ft?{w:a*12,h:b*12}:{w:a,h:b};
}
function selectedOptions(){
var out={};
$all('select[name^="options["]').forEach(function(s){ out[s.name.slice(8,-1)]=s.value; });
$all('input[type=radio][name^="options["]:checked, fieldset input[type=radio]:checked').forEach(function(r){ var n=(r.name||'').replace(/^options\[|\]$/g,''); if(n&&!out[n]) out[n]=r.value; });
return out;
}
window.PZSE={CANVAS_PX:CANVAS_PX,WORK_LONG:WORK_LONG,$:$,$all:$all,distanceOutside:distanceOutside,fillHoles:fillHoles,countComponents:countComponents,maskToCanvas:maskToCanvas,analyzeArt:analyzeArt,sampleArt:sampleArt,parseLen:parseLen,parsePair:parsePair,selectedOptions:selectedOptions};
})();